<template>
  <div v-if="future" id="promo-timer" class="promo-timer">
    <div v-if="d > 0" class="promo-timer--part">{{ d }}<span class="promo-timer--part__text">{{ $gettext('Days') }}</span></div>
    <div class="promo-timer--part">{{ h }}<span class="promo-timer--part__text">{{ $gettext('Hours') }}</span></div>
    <div class="promo-timer--part">{{ m }}<span class="promo-timer--part__text">{{ $gettext('Mins') }}</span></div>
    <div class="promo-timer--part">{{ s }}<span class="promo-timer--part__text">{{ $gettext('Secs') }}</span></div>
  </div>
</template>

<script>
export default {
  props: {
    timeUntil: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      d: 0,
      h: 0,
      m: 0,
      s: 0,
      future: null
    }
  },
  mounted () {
    this.updateTimer()
    this.$nextTick(() => {
      this.timer = setInterval(() => {
        this.updateTimer()
      }, 1000)
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    updateTimer () {
      this.future = Date.parse(this.timeUntil)
      if (Number.isNaN(this.future)) {
        this.d = '00'
        this.h = '00'
        this.m = '00'
        this.s = '00'
        return
      }

      const now = new Date()
      const diff = Math.max(0, this.future - now)

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(diff / (1000 * 60 * 60))
      const mins = Math.floor(diff / (1000 * 60))
      const secs = Math.floor(diff / 1000)

      this.d = days
      this.d = (this.d < 10) ? '0' + this.d : this.d

      this.h = hours - days * 24
      this.h = (this.h < 10) ? '0' + this.h : this.h

      this.m = mins - hours * 60
      this.m = (this.m < 10) ? '0' + this.m : this.m

      this.s = secs - mins * 60
      this.s = (this.s < 10) ? '0' + this.s : this.s
    }
  }
}
</script>

<style lang="scss" scoped>
  .promo-timer {
    font-size: 18px;
    color: white;
    text-align: center;
    margin-left: 10px;
    @media (min-width: 640px) {
      font-size: 28px;
      margin: 0;
    }
    &--part {
      display: inline-block;
      @media (min-width: 640px) {
        width: 42px;
      }
      &__text {
        margin-left: 3px;
        @media (min-width: 640px) { 
          display: block;
          margin-left: 0;
          margin-top: 4px;
        }
        font-size: 12px;
        font-weight: 400;
        line-height: 1;
      }
    }
  }
</style>
